export const WalletTransferType = {
  MAIN: 'MAIN',
  CUSTOMER: 'CUSTOMER',
} as const

export type WalletTransferType = (typeof WalletTransferType)[keyof typeof WalletTransferType]

export const PayoutInstructionTypes = {
  FIAT: 'FIAT',
  CRYPTO: 'CRYPTO',
  WALLET: 'WALLET',
}

export type PayoutInstructionType =
  (typeof PayoutInstructionTypes)[keyof typeof PayoutInstructionTypes]

interface Amount {
  value: string
  currency: string
}

// Internal Transfers

export interface TransferWalletsRequest {
  walletId: string
  currencyCode: string
  walletType: string
  customerReference: string
  walletName?: string
  pageNumber?: number
  pageSize?: number
}

interface Balance {
  value: string
  currency: string
}

export interface TransferWalletsReponse {
  walletId: string
  balance: Balance
  currencyCode: string
  description: string
  name: string
  walletType: string
}

interface TransferRequestFees {
  customerFee?: Amount
}

interface TransferRequestBeneficiary {
  walletId: string
}
interface TransferRequestMetadata {
  [key: string]: string
}
export interface TransferRequest {
  walletId: string
  amount: string
  currency: string
  reference: string
  fees?: TransferRequestFees
  beneficiary: TransferRequestBeneficiary
  metadata?: TransferRequestMetadata
}

interface TransferResponseFees {
  processingFee?: Amount
}

interface TransferCounterpartyEntity {
  legalName: string
  type: string
}
interface TransferCounterparty {
  amount: number
  currency: string
  entity: TransferCounterpartyEntity
  walletId: string
}
export interface TransferResponse {
  id: string
  reference: string
  status: string
  fees?: TransferResponseFees
  originator: TransferCounterparty
  beneficiary: TransferCounterparty
  createdAt: string
  updatedAt: string
  type: string
  method: string
}

export interface IndividualDetails {
  firstName: string
  lastName: string
  dateOfBirth: string
}
